import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import I18n from '@app/modules/i18n';
import Action from '@app/component/preview/action';
import Icon from '@app/component/icon';

const DirectoryWrapper = ({ title, action, className, insideGrid }) => {
  const containerClassName = classnames('preview__container', className, {
    'preview__container--grid': insideGrid,
  });

  return (
    <div className={containerClassName}>
      <Icon className="preview__item--icon" type="Fallback" />
      <Action
        title={title}
        subTitle={I18n.t('transfer.item.details.folder')}
        action={action}
        className="preview__bar-notsupported"
        icon
      />
    </div>
  );
};

DirectoryWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.object.isRequired,
  className: PropTypes.string,
  insideGrid: PropTypes.bool,
};

export default React.memo(DirectoryWrapper);
